import CustomTag from "components/Atoms/CustomTag"
import CustomTooltip from "components/Atoms/CustomTooltip"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import { useBenchmarkRecommendations } from "graphql/benchmark.graphql.gql"
import React from "react"
import { inr } from "utils/formatters.utils"
dayjs.extend(advancedFormat)

interface BenchmarkRateProps {
  /**
   * The currently selected varietyGroup object
   */
  commodityGroup: any
  first?: number
}
const BenchmarkRate = ({ commodityGroup, first }: BenchmarkRateProps) => {
  const { data } = useBenchmarkRecommendations(commodityGroup?.id, [], first)
  if (!commodityGroup?.id)
    return <p className="my-3">Please select a variety group</p>
  return (
    <div className="mt-3">
      {data?.allPriceBenchmarkRecommendations?.map(p => {
        const recommended = p?.recommendedPrice
        const priceUnit =
          recommended?.pricingDoneOn === "SKU"
            ? recommended.priceUnit
            : recommended?.uomType

        return (
          <CustomTooltip
            key={p?.id}
            content={<div>{p?.marketYard.name} Market Yard</div>}
          >
            <div className="my-2" key={p?.id}>
              <CustomTag round minimal className="mr-3">
                {dayjs(p?.date).format("Do MMMM")}
              </CustomTag>
              <span className="vt-muted">{p?.grade.name} @</span>{" "}
              <span
                style={{
                  color: "#293742",
                  fontWeight: 600,
                }}
              >
                {inr(recommended?.price)} / {priceUnit?.name}
              </span>
            </div>
          </CustomTooltip>
        )
      })}
    </div>
  )
}

export default BenchmarkRate
